import { AutoComplete, Button, Input, Spin, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';
import SendRewardSlider from './SendRewardSlider.jsx';
import {
	addCommas,
	getBadgeCategoryLabel,
} from '../../../rewardsAndRecognitionHelper/utils.js';

const SendRewardModal = (props) => {
	const {
		currentUser = {},
		sendRewardObject,
		setSendRewardObject,
		checkAllEligibility,
		setIsOpenRewardModel,
		badgeData,
		isBadgeLoading,
		errorObject,
		setErrorObject,
		rewardsAvailable,
		handleSendShoutout,
	} = props;
	const [inputValue, setInputValue] = useState('');
	const [selectedPage, setSelectedPage] = useState(null);
	const companyId = currentUser?.companyId || '';

	const rewardList = badgeData?.map((badge) => {
		const category = getBadgeCategoryLabel(badge);
		return {
			value: badge.id,
			label: (
				<span>
					{badge?.name}{' '}
					<span className="badge-count">
						{`(${addCommas(badge?.points)} points${category ? ` · ${category}` : ''})`}
					</span>
				</span>
			),
			name: badge?.name,
		};
	});
	const handleSearch = async (value) => {
		setInputValue(value);
		setSendRewardObject({
			...sendRewardObject,
			rewardtype: null,
			selectedBadge: null,
		});
		setSelectedPage(0);
	};
	return (
		<div className="send-reward-modal">
			<div className="select-recipient-text">
				{companyId === 'c816b4bf-a851-4bdb-bf4e-a5c9cd27bef1'
					? 'Select a BizTech Behavior or Airbnb Core Value this individual has demonstrated.'
					: "Select a recognition to send and recognize your colleague's achievements."}
			</div>

			<div>
				{isBadgeLoading ? (
					<Spin className="spinner" />
				) : (
					<div>
						<div
							className="custom-form-group"
							style={{ padding: '0', margin: 0 }}
						>
							<AutoComplete
								allowClear
								value={inputValue}
								className="w-100 custom-input search-recognitions"
								options={rewardList}
								filterOption={(inputValue, option) =>
									option?.name
										.toUpperCase()
										.indexOf(inputValue.toUpperCase()) !== -1
								}
								onChange={handleSearch}
								onSelect={(value, option) => {
									const selectedReward = badgeData?.find(
										(badge) => badge.id === value
									);
									const selectedIndex = badgeData?.findIndex(
										(badge) => badge.id === value
									);
									const selectedPage = Math.floor(selectedIndex / 3) * 3;
									setSendRewardObject({
										...sendRewardObject,
										rewardtype: value,
										selectedBadge: selectedReward,
									});
									setSelectedPage(selectedPage);
									setInputValue(selectedReward?.name || '');
									setErrorObject({
										...errorObject,
										rewardtype: false,
									});
								}}
								placeholder={
									<>
										<SearchOutlined />
										<span> Search all recognitions</span>
									</>
								}
							/>
							{errorObject?.rewardtype === true ? (
								<div class="ant-form-explain mt-1">Please add recognition</div>
							) : (
								<></>
							)}
						</div>

						{rewardsAvailable ? (
							<SendRewardSlider
								badgeData={badgeData}
								selectedPage={selectedPage}
								setSendRewardObject={setSendRewardObject}
								sendRewardObject={sendRewardObject}
								currentUser={currentUser}
							/>
						) : (
							<div className="d-flex alig-items-center justify-items-center">
								No recognitions available
							</div>
						)}
					</div>
				)}
			</div>

			<div
				className="d-flex justify-content-center pt-4"
				style={{ marginTop: '20px' }}
			>
				<Button
					className="blue-bg-btn"
					onClick={() => {
						if (
							sendRewardObject?.rewardtype !== undefined &&
							sendRewardObject?.rewardtype !== null
						) {
							message.success('Your recognition has been saved');
						}
						checkAllEligibility();
						setIsOpenRewardModel(false);
						handleSendShoutout();
					}}
					disabled={
						sendRewardObject?.rewardtype === undefined ||
						sendRewardObject?.rewardtype === null
					}
				>
					Select
				</Button>
			</div>
		</div>
	);
};
export default SendRewardModal;
